/**
 * @fileoverview Barrel exports for the prose-continuer-discovery agent.
 *
 * Discovery continuation: exploratory, character-driven writing.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow, proseContinuerDiscoveryAgentFlow } from './flow';

// Prompt template
export { prompt } from './prompt';
